// React Imports
import React, { Component } from "react";
import AboutDetail from "../components/AboutDetail";

export default class AboutPage extends Component {

    render() {
        return <AboutDetail/>;
    }
}



/** WEBPACK FOOTER **
 ** ./src/containers/AboutPage.js
 **/